import { Grid } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import SimpleTable from "components/Tables/SimpleTable";
import dataResiduosGenerados from "./dataResiduosGenerados";
import SinDatos from "components/Carteles/SinDatos";
import Firma from "../Firma";

const ResiduosGenerados = ({ listadoResiduosGenerados }) => {
  const { columns, getRows } = dataResiduosGenerados;

  const memoizedRows = useMemo(() => {
    if (listadoResiduosGenerados) {
      const listadoSinBorrar = listadoResiduosGenerados.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar);
    }
    return [];
  }, [listadoResiduosGenerados]);

  return (
    <Grid container p={2}>
      <Grid item xs={12}>
        <SoftTypography color="black" variant="h4" fontWeight="bold">
          Residuos Generados
        </SoftTypography>
      </Grid>
      <Grid item xs={12} py={1}>
        {listadoResiduosGenerados?.filter((item) => !item.aBorrar).length > 0 ? (
          <SimpleTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay residuos generados cargados" />
        )}
      </Grid>
      <Firma marginTop={10} />
    </Grid>
  );
};

export default memo(ResiduosGenerados);

ResiduosGenerados.propTypes = {
  listadoResiduosGenerados: PropTypes.array.isRequired,
};
